/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlReportedAssetResponse
 */
export interface ControlReportedAssetResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    user?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    entity_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    asset_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    removed?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    created: string;
    /**
     * 
     * @type {string}
     * @memberof ControlReportedAssetResponse
     */
    updated: string;
}

/**
 * Check if a given object implements the ControlReportedAssetResponse interface.
 */
export function instanceOfControlReportedAssetResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "entity_id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;

    return isInstance;
}

export function ControlReportedAssetResponseFromJSON(json: any): ControlReportedAssetResponse {
    return ControlReportedAssetResponseFromJSONTyped(json, false);
}

export function ControlReportedAssetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlReportedAssetResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : json['user'],
        'entity_id': json['entity_id'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'reason': !exists(json, 'reason') ? undefined : json['reason'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'asset_type': !exists(json, 'asset_type') ? undefined : json['asset_type'],
        'removed': !exists(json, 'removed') ? undefined : json['removed'],
        'created': json['created'],
        'updated': json['updated'],
    };
}

export function ControlReportedAssetResponseToJSON(value?: ControlReportedAssetResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'entity_id': value.entity_id,
        'asset': value.asset,
        'status': value.status,
        'reason': value.reason,
        'code': value.code,
        'asset_type': value.asset_type,
        'removed': value.removed,
        'created': value.created,
        'updated': value.updated,
    };
}

